import { render, staticRenderFns } from "./VideoInput.vue?vue&type=template&id=27c0c4e7&scoped=true&"
import script from "./VideoInput.vue?vue&type=script&lang=js&"
export * from "./VideoInput.vue?vue&type=script&lang=js&"
import style0 from "./VideoInput.vue?vue&type=style&index=0&id=27c0c4e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c0c4e7",
  null
  
)

export default component.exports